var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OrderForm',{attrs:{"order":_vm.order,"buttonLoading":_vm.buttonLoading,"params":_vm.getParams},on:{"saveOrder":_vm.saveOrder}})}
var staticRenderFns = []

export { render, staticRenderFns }